import { Card, Tag, Typography } from "@arco-design/web-react";

const { Title, Text } = Typography;

/** 待办事项数据结构。 */
export interface TodoItem {
  title: string;
  count: string;
  note: string;
  tag: string;
}

/** 待处理事项面板。 */
export function TodoPanel({ items }: { items: TodoItem[] }) {
  return (
    <Card
      bodyStyle={{ padding: 22 }}
      style={{
        height: "100%",
        border: "1px solid #e5e6eb",
        borderRadius: 20,
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
      }}
    >
      <Title heading={5} style={{ marginTop: 0 }}>
        待处理事项
      </Title>
      <div style={{ display: "grid", gap: 12 }}>
        {items.map((item) => (
          <div
            key={item.title}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #f2f3f5",
              borderRadius: 16,
              padding: "14px 16px",
              background: "#fcfcfd",
            }}
          >
            <div>
              <div style={{ marginBottom: 6, color: "#1d2129", fontWeight: 600 }}>{item.title}</div>
              <Text style={{ color: "#86909c", fontSize: 13 }}>{item.note}</Text>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ marginBottom: 6, color: "#1d2129", fontSize: 24, fontWeight: 700 }}>
                {item.count}
              </div>
              <Tag color="arcoblue">{item.tag}</Tag>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
